<script setup lang="ts">
import { tpgIconInfo } from '@tpg/grammar-web-icons';
import { computed, ref, toRefs } from 'vue';

import { GrammarBadge, GrammarIcon } from '@nora-monorepo/grammar-ui';

import type { NoraMap } from '#nora-ui/map/map/NoraMap';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface MapAttributionsProps {
  mapId: string;
}

const props = defineProps<MapAttributionsProps>();
const { mapId } = toRefs(props);
const isVisible = ref(false);

const mapStore = useMapStore();

const map = computed<NoraMap>(() => {
  return mapStore.getMapByIdOrThrow(mapId.value);
});

const attributions = computed(() => {
  return map.value.getAttributions();
});

function toggleVisibility() {
  isVisible.value = !isVisible.value;
}
</script>

<template>
  <div
    v-if="attributions.length > 0"
    class="flex flex-row items-center h-6 pointer-events-auto select-none"
  >
    <button
      v-if="isVisible"
      class="flex flex-row gap-1 "
      @click="toggleVisibility"
    >
      <GrammarBadge
        v-for="attribution in attributions"
        :key="attribution"
        :label="attribution"
        size="lg"
        type="neutral"
        emphasis="default"
      />
    </button>
    <button
      v-else
      title="Show attributions"
      @click="toggleVisibility"
    >
      <GrammarIcon
        :icon-template="tpgIconInfo"
        style="--iconVectorFill: #000"
      />
    </button>
  </div>
</template>
